/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReferenceMaterial } from '../../models/reference-material';

export interface ReferenceMaterialControllerCreate$Params {
      body: {

/**
 * the document, application/pdf
 */
'file': Blob;
'ilsId': string;
'title': string;
'materialType': 'bookChapter';
}
}

export function referenceMaterialControllerCreate(http: HttpClient, rootUrl: string, params: ReferenceMaterialControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReferenceMaterial>> {
  const rb = new RequestBuilder(rootUrl, referenceMaterialControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReferenceMaterial>;
    })
  );
}

referenceMaterialControllerCreate.PATH = '/reference-material/upload';
